<p-toast></p-toast>
<div class="p-grid p-justify-center">
    <div class="p-col-12 p-md-10 p-lg-8">
        <div class="card shadow-lg border-0">
            <div class="card-header text-white" style="background: linear-gradient(to right, #007bff, #6610f2);">
                <h3 class="mb-0">Grievance Form</h3>
            </div>
            <div class="card-body p-fluid">
                <form [formGroup]="grievanceForm" (ngSubmit)="onSubmit()">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <!-- User Type Dropdown -->
                        <div class="field md:col-4 col-12">
                            <label for="userType">User Type</label>
                            <p-dropdown [options]="userTypes" formControlName="userType"
                                placeholder="Select User Type"></p-dropdown>
                            <div *ngIf="grievanceForm?.controls['userType']?.invalid && grievanceForm?.controls['userType']?.touched"
                                class="invalid-feedback">
                                User Type is required.
                            </div>
                        </div>

                        <!-- User Name -->
                        <div class="field md:col-4 col-12">
                            <label for="userName">User Name</label>
                            <input pInputText type="text" id="userName" class="form-control" formControlName="userName">
                            <div *ngIf="grievanceForm?.controls['userName']?.invalid && grievanceForm?.controls['userName']?.touched"
                                class="invalid-feedback">
                                User Name is required.
                            </div>
                        </div>

                        <!-- Mobile Number -->
                        <div class="field md:col-4 col-12">
                            <label for="mobileNumber">Mobile Number</label>
                            <input pInputText type="tel" id="mobileNumber" class="form-control"
                                formControlName="mobileNumber">
                            <div *ngIf="grievanceForm?.controls['mobileNumber']?.invalid && grievanceForm?.controls['mobileNumber']?.touched"
                                class="invalid-feedback">
                                Mobile Number is required and must be 10 digits.
                            </div>
                        </div>

                        <!-- Email ID -->
                        <div class="field md:col-4 col-12">
                            <label for="emailId">Email ID</label>
                            <input pInputText type="email" id="emailId" class="form-control" formControlName="emailId">
                            <div *ngIf="grievanceForm?.controls['emailId']?.invalid && grievanceForm?.controls['emailId']?.touched"
                                class="invalid-feedback">
                                Please enter a valid email address.
                            </div>
                        </div>

                        <!-- Address -->
                        <div class="field md:col-4 col-12">
                            <label for="address">Address</label>
                            <input pInputText type="text" id="address" class="form-control" formControlName="address">
                        </div>

                        <!-- File Upload -->
                        <div class="field md:col-4 col-12">
                            <label for="fileUpload">Upload Document</label>
                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #grievanceCopyPath [customUpload]="true"
                                (uploadHandler)="onUpload($event, 'grievanceCopyPath', grievanceCopyPath)"
                                name="myfile[]" mode="basic" [maxFileSize]="1000000" chooseLabel="Browse" [auto]="true">
                                <!-- <ng-template pTemplate="content">
                                    <input type="file" (change)="onFileChange($event)" class="form-control-file">
                                </ng-template> -->
                            </p-fileUpload>
                            <p-image *ngIf="grievanceForm?.controls['grievanceCopyPath']?.value"
                                [src]="grievanceForm?.controls['grievanceCopyPath']?.value" alt="Image" width="60"
                                class="ml-2 p-button-rounded p-button-success" iconPos="left">
                            </p-image>
                            <small class="form-text text-muted">Max file size: 10MB</small>
                            <div *ngIf="grievanceForm?.controls['grievanceCopyPath']?.invalid && grievanceForm?.controls['grievanceCopyPath']?.touched"
                                class="invalid-feedback">
                                Please upload a valid file.
                            </div>
                        </div>

                        <!-- select category -->
                        <div class="field md:col-4 col-12">
                            <label for="category">Select Category</label>
                            <p-dropdown [options]="categoryList" formControlName="category" optionLabel="Category_Type"
                                optionValue="Category_Type" placeholder="{{'Select Category'| translate}}" appendTo="body">
                            </p-dropdown>
                            <div *ngIf="grievanceForm?.controls['category']?.invalid && grievanceForm?.controls['category']?.touched"
                                class="invalid-feedback">
                                Category is required.
                            </div>
                        </div>

                        <!-- Description -->
                        <div class="field md:col-8 col-12">
                            <label for="description">Description</label>
                            <textarea pInputTextarea id="description" rows="4" class="form-control"
                                formControlName="description"></textarea>
                            <div *ngIf="grievanceForm?.controls['description']?.invalid && grievanceForm?.controls['description']?.touched"
                                class="invalid-feedback">
                                Please enter description.
                            </div>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="p-grid">
                        <div class="p-col-12">
                            <button pButton type="submit" label="Submit" class="btn btn-green btn-block"></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<div class="p-fluid p-formgrid justify-content-center mt-2" style="display: flex; flex-wrap:wrap">
    <div class="field md:col-6 col-12">
        <button pButton type="submit" label="Track Application" (click)="onClickTrackApp()"
            class="btn btn-primary btn-block"></button>
    </div>
</div>

    <div #grievanceDataTable *ngIf="grievanceTableData.length > 0" class="card dashboardTable">
        <p-table [value]="grievanceTableData" [rows]="10" [paginator]="false" responsiveLayout="scroll" [rowHover]="true"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <!-- <p-table [value]="grievanceTableData" responsiveLayout="scroll"> -->
            <!-- <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        Products
                        <p-button icon="pi pi-refresh" />
                    </div>
                </ng-template> -->
            <ng-template pTemplate="header">
                <tr>
                    <th>Ticket No</th>
                    <th>Name</th>
                    <th>Mobile No</th>
                    <th>Email Id</th>
                    <th>Address</th>
                    <th>Date</th>
                    <th>Grievance Type</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Doc Path</th>
                    <th>Dept Remarks</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                    <!-- <td>{{product.TicketNo}}</td> -->
                    <td><p-tag [value]="product.TicketNo" [severity]="getSeverity(product.Status)"></p-tag></td>
                    <td>{{product.User_Name}}</td>
                    <td>{{product.Mobile_No }}</td>
                    <td>{{product.EmailID}}</td>
                    <td>{{product.Address}}</td>
                    <td>{{product.Date | date:'mediumDate'}}</td>
                    <td>{{product.GrievanceType}}</td>
                    <td>{{product.BriefDescription}}</td>
                    <td><p-tag [value]="product.Status" [severity]="getSeverity(product.Status)"></p-tag></td>
                    <td>
                        <a style="cursor: pointer" icon="pi pi-eye" [href]="product?.Doc_Path" target="_blank">
                            <button pButton type="button"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                            pTooltip="View" icon="pi pi-eye"></button>
                        </a>
                    </td>
                    <td>{{product.Remarks}}</td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        In total there are {{products ? products.length : 0 }} products.
                    </div>
                </ng-template> -->
        </p-table>
    </div>
<!-- </div> -->